import { render, staticRenderFns } from "./DatabaseTable.vue?vue&type=template&id=0708b49f"
import script from "./DatabaseTable.vue?vue&type=script&lang=js"
export * from "./DatabaseTable.vue?vue&type=script&lang=js"
import style0 from "./DatabaseTable.vue?vue&type=style&index=0&id=0708b49f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports